<div class="mb-8 lg:mb-12 lg:pr-[6px]">
  <mobo-banner></mobo-banner>
</div>
<div class="max-w-6xl mx-auto px-4 flex flex-col gap-8 lg:gap-20">
  <div class="hidden lg:flex w-full items-center -mb-8">
    <div class="flex w-full gap-3 overflow-x-auto pb-1">
      <button
        class="border border-[#d00000] rounded-full py-3 px-6 transition-all focus:outline-none items-center"
        (click)="showOnlyDelivery = !showOnlyDelivery"
        [ngClass]="
          showOnlyDelivery
            ? 'bg-[#d00000] text-white hover:bg-white hover:text-[#d00000]'
            : 'bg-white text-[#d00000] hover:bg-[#d00000] hover:text-white'
        "
      >
        <svg
          width="94"
          height="22"
          viewBox="0 0 94 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.979032 1.16277C0.625268 1.16277 0.457503 1.59677 0.716444 1.83566L1.43856 2.49942C2.54362 3.5133 3.98785 4.07495 5.48861 4.07495H8.98067L5.61444 15.3334C5.41932 15.9607 5.45032 16.4494 5.70561 16.8013C5.96273 17.1533 6.40403 17.3283 7.02949 17.3283H11.9822C14.03 17.3283 15.8025 16.9272 17.2996 16.1248C18.7949 15.3225 19.9929 14.2265 20.8919 12.8352C21.7909 11.4438 22.3526 9.8847 22.5805 8.15782C22.8905 5.95683 22.4128 4.24089 21.1491 3.01001C19.8854 1.77913 17.9378 1.1646 15.3101 1.1646H0.979032V1.16277ZM18.8624 8.20159C18.691 9.42517 18.3408 10.5029 17.812 11.4347C17.2832 12.3665 16.5738 13.0978 15.6821 13.6248C14.7904 14.1518 13.7091 14.4162 12.4417 14.4162H9.43837L12.542 4.07495H14.9035C16.4006 4.07495 17.482 4.43053 18.1475 5.14171C18.8113 5.85289 19.0502 6.87224 18.8642 8.20341L18.8624 8.20159Z"
            fill="currentColor"
          />
          <path
            d="M33.1789 6.67712C32.5078 6.11912 31.5377 5.84012 30.2703 5.84012C29.003 5.84012 27.918 6.11912 26.8859 6.67712C25.8519 7.23512 24.9949 8.00647 24.3129 8.993C23.6309 9.97953 23.2005 11.1138 23.02 12.3975C22.8741 13.4369 22.9835 14.3432 23.3482 15.1146C23.7129 15.8859 24.3019 16.4895 25.1116 16.9253C25.9212 17.3612 26.9151 17.5782 28.0931 17.5782C28.6729 17.5782 29.3093 17.5089 30.0023 17.3721C30.6934 17.2353 31.328 17.0129 31.9079 16.7065C32.3182 16.5078 32.6099 16.2452 32.7868 15.9151C32.9619 15.5869 33.0275 15.2696 32.9783 14.9632C32.9291 14.6569 32.7722 14.4399 32.5078 14.3104C32.2434 14.1809 31.8823 14.2229 31.4246 14.4362C31.0326 14.6204 30.5968 14.7572 30.1172 14.8483C29.6376 14.9395 29.1999 14.9851 28.8024 14.9851C27.8706 14.9851 27.1831 14.7645 26.74 14.3195C26.2987 13.8764 26.1255 13.2491 26.2239 12.4395H33.2409C33.4998 12.4395 33.7132 12.3902 33.8809 12.2899C34.0469 12.1915 34.1782 11.9654 34.2748 11.6134C34.5192 10.636 34.5666 9.706 34.4134 8.82706C34.2621 7.94812 33.8499 7.22965 33.1807 6.67165L33.1789 6.67712ZM31.7255 10.6561H26.7272C26.9771 9.96859 27.3655 9.37594 27.8943 8.87812C28.4231 8.38212 29.0996 8.13229 29.9257 8.13229C30.7518 8.13229 31.2569 8.373 31.5322 8.85441C31.8076 9.33582 31.8732 9.93576 31.7255 10.6542V10.6561Z"
            fill="currentColor"
          />
          <path
            d="M40.4383 14.7371C40.3472 14.7371 40.2505 14.7444 40.1484 14.7608C40.0463 14.7754 39.9186 14.7845 39.7673 14.7845C39.3387 14.7845 39.0415 14.6441 38.8756 14.3596C38.7096 14.077 38.7151 13.6302 38.892 13.0175L41.9081 2.97354C42.1032 2.34624 42.0996 1.85389 41.8972 1.49466C41.6947 1.13542 41.3264 0.954892 40.7921 0.954892C39.6305 0.954892 38.8829 1.5366 38.5528 2.69818L35.4218 13.0631C34.986 14.5311 35.0152 15.6507 35.5112 16.422C36.0072 17.1934 36.9426 17.58 38.3176 17.58C38.5309 17.58 38.7589 17.5654 39.0014 17.5344C39.2421 17.5034 39.4354 17.4651 39.5794 17.4195C39.884 17.3138 40.163 17.1259 40.4146 16.8579C40.6663 16.5898 40.8304 16.1813 40.9088 15.6306C40.958 15.2787 40.938 15.0416 40.8486 14.9195C40.7593 14.7973 40.6225 14.7353 40.4383 14.7353V14.7371Z"
            fill="currentColor"
          />
          <path
            d="M46.4742 5.88753C45.3272 5.88753 44.5814 6.46012 44.2367 7.60712L41.8643 15.5176C41.6692 16.1449 41.6729 16.6372 41.8734 16.9965C42.0759 17.3557 42.4424 17.5344 42.9785 17.5344C44.1255 17.5344 44.8713 16.9618 45.216 15.8148L47.5884 7.90435C47.7853 7.26247 47.7835 6.76647 47.5793 6.41453C47.3769 6.06259 47.0067 5.88753 46.4724 5.88753H46.4742Z"
            fill="currentColor"
          />
          <path
            d="M60.5464 6.50571C60.3987 6.09359 59.9957 5.88753 59.3374 5.88753C58.8942 5.88753 58.5186 5.97506 58.2104 6.15194C57.9023 6.32883 57.5959 6.637 57.2895 7.08012L52.9404 13.2254L52.3988 7.44665C52.3423 6.86677 52.2055 6.46012 51.9849 6.23218C51.7643 6.00241 51.4178 5.88753 50.9437 5.88753C50.3164 5.88753 49.824 6.10453 49.4648 6.54036C49.1056 6.97618 48.9761 7.53782 49.0782 8.22529L50.1249 15.9534C50.2051 16.4731 50.382 16.867 50.6574 17.135C50.9327 17.4031 51.3467 17.5362 51.8974 17.5362C52.2949 17.5362 52.6633 17.4359 53.0061 17.239C53.3471 17.0402 53.6863 16.7193 54.0236 16.2762L60.1689 7.95359C60.5664 7.40288 60.6922 6.92147 60.5445 6.50936L60.5464 6.50571Z"
            fill="currentColor"
          />
          <path
            d="M69.6822 6.67712C69.0112 6.11912 68.0411 5.84012 66.7737 5.84012C65.5064 5.84012 64.4214 6.11912 63.3892 6.67712C62.3553 7.23512 61.4982 8.00647 60.8162 8.993C60.1342 9.97953 59.7039 11.1138 59.5234 12.3975C59.3775 13.4369 59.4869 14.3432 59.8516 15.1146C60.2163 15.8859 60.8053 16.4895 61.6149 16.9253C62.4246 17.3612 63.4184 17.5782 64.5964 17.5782C65.1763 17.5782 65.8127 17.5089 66.5057 17.3721C67.1968 17.2353 67.8332 17.0129 68.4112 16.7065C68.8215 16.5078 69.1133 16.2452 69.2902 15.9151C69.4652 15.5869 69.5309 15.2696 69.4816 14.9632C69.4324 14.6569 69.2756 14.4399 69.0112 14.3104C68.7468 14.1809 68.3857 14.2229 67.928 14.4362C67.5359 14.6204 67.1001 14.7572 66.6205 14.8483C66.1409 14.9395 65.7033 14.9851 65.3058 14.9851C64.3739 14.9851 63.6865 14.7645 63.2434 14.3195C62.8021 13.8764 62.6288 13.2491 62.7273 12.4395H69.7442C70.0032 12.4395 70.2165 12.3902 70.3843 12.2899C70.5502 12.1915 70.6815 11.9654 70.7782 11.6134C71.0225 10.636 71.0699 9.706 70.9168 8.82706C70.7654 7.94812 70.3533 7.22965 69.6841 6.67165L69.6822 6.67712ZM68.2289 10.6561H63.2306C63.4804 9.96859 63.8688 9.37594 64.3977 8.87812C64.9265 8.38212 65.603 8.13229 66.4291 8.13229C67.2551 8.13229 67.7602 8.373 68.0356 8.85441C68.3109 9.33582 68.3766 9.93576 68.2307 10.6542L68.2289 10.6561Z"
            fill="currentColor"
          />
          <path
            d="M81.7485 6.96341C81.805 6.56588 81.754 6.27594 81.5953 6.09177C81.4385 5.90759 81.1285 5.82371 80.6672 5.84012C79.883 5.87112 79.1591 6.07353 78.4953 6.44736C77.8316 6.82118 77.2699 7.33724 76.8104 7.99553L76.8815 7.81135C77.0584 7.20047 77.0493 6.72636 76.8523 6.389C76.6554 6.05347 76.2816 5.88389 75.7309 5.88389C74.6149 5.88389 73.8946 6.43459 73.5718 7.53418L71.1793 15.5832C70.9861 16.1941 70.9915 16.6719 71.1958 17.0165C71.4 17.3612 71.7848 17.5326 72.35 17.5326C73.5262 17.5326 74.2775 16.9746 74.6039 15.8586L75.8549 11.6863C76.112 10.8311 76.4676 10.1765 76.9216 9.72606C77.3757 9.27565 78.0668 9.00394 78.9968 8.91277L79.7627 8.84347C80.3681 8.78329 80.8276 8.61006 81.1413 8.32741C81.4567 8.04477 81.6573 7.59071 81.7467 6.96341H81.7485Z"
            fill="currentColor"
          />
          <path
            d="M93.8367 6.51665C93.6744 6.09724 93.2641 5.88571 92.6076 5.88571C92.1645 5.88571 91.7925 5.98053 91.4898 6.172C91.1871 6.36347 90.8826 6.68077 90.5762 7.12388L86.2344 13.2236L85.6709 7.44482C85.629 6.86494 85.5032 6.4583 85.2916 6.23035C85.0801 6.00059 84.7354 5.88571 84.2632 5.88571C83.6359 5.88571 83.1399 6.10271 82.7733 6.53853C82.4068 6.97435 82.2737 7.536 82.3758 8.22347L83.5447 16.7065L81.3765 19.5731C80.9644 20.1074 80.8331 20.5888 80.979 21.0173C81.1249 21.4459 81.526 21.6592 82.1843 21.6592C82.6274 21.6592 82.9994 21.5644 83.3021 21.3729C83.6049 21.1815 83.9167 20.8642 84.2376 20.421L93.4847 7.97C93.8822 7.41929 94.0008 6.93424 93.8385 6.513L93.8367 6.51665Z"
            fill="currentColor"
          />
          <path
            d="M48.5477 3.77083C49.5875 3.09562 49.995 1.87792 49.458 1.05102C48.9211 0.224132 47.6429 0.101172 46.6031 0.776387C45.5634 1.4516 45.1558 2.6693 45.6928 3.4962C46.2298 4.32309 47.508 4.44605 48.5477 3.77083Z"
            fill="currentColor"
          />
        </svg>
      </button>

      <ng-container *ngFor="let fastFilter of fastFilters">
        <button
          class="flex items-center border font-medium text-xl rounded-full py-2 px-6 transition-all focus:outline-none"
          [ngClass]="
            isFilterSelected(fastFilter.id)
              ? fastFilter.regularClasses
              : fastFilter.activeClasses
          "
          (click)="toggleFastFilter(fastFilter)"
        >
          {{ fastFilter.description }}
        </button>
      </ng-container>
    </div>

    <mobo-filter-modal
      extraClass="!rounded-full -mt-px"
      #filter
      (updateFilter)="addFilters($event)"
      (filterDone)="searchFilters()"
    >
      <div
        class="text-primary-500 bg-[#EBEFFF] rounded-full flex gap-4 items-center mb-auto py-3 px-6"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
        >
          <path d="M2.65869 5.5H14.6587" stroke="#3D5CF5" stroke-width="1.2" />
          <path d="M22.6587 12.5H10.6587" stroke="#3D5CF5" stroke-width="1.2" />
          <path d="M22.6587 19.5H14.1587" stroke="#3D5CF5" stroke-width="1.2" />
          <path d="M17.6587 5.5H22.6587" stroke="#3D5CF5" stroke-width="1.2" />
          <path d="M7.65869 12.5H2.65869" stroke="#3D5CF5" stroke-width="1.2" />
          <path d="M11.6587 19.5H2.65864" stroke="#3D5CF5" stroke-width="1.2" />
          <path
            d="M14.6587 8.5L14.6587 2.5"
            stroke="#3D5CF5"
            stroke-width="1.2"
          />
          <path
            d="M7.65869 15.5L7.65869 9.5"
            stroke="#3D5CF5"
            stroke-width="1.2"
          />
          <path
            d="M14.6587 22.5L14.6587 16.5"
            stroke="#3D5CF5"
            stroke-width="1.2"
          />
        </svg>
        Filtrar
      </div>
    </mobo-filter-modal>
  </div>

  <div
    class="flex flex-wrap items-center -my-8 gap-2"
    *ngIf="(filters && filters[0]) || showOnlyDelivery"
  >
    <div
      *ngIf="showOnlyDelivery"
      class="flex gap-2 items-center px-3 py-1 rounded-full transition-all border-2 text-xs select-none text-slate-500 border-slate-300"
    >
      Delivery
    </div>
    <div
      *ngFor="let filter of filters"
      class="flex gap-2 items-center px-3 py-1 rounded-full transition-all border-2 text-xs select-none text-slate-500 border-slate-300"
    >
      {{ filter.description }}
    </div>
    <div
      class="flex gap-2 items-center pl-3 rounded-full transition-all border-2 text-xs select-none text-error-500 border-error-500 cursor-pointer"
      (click)="clearFilter()"
    >
      Limpar filtros
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        class="fill-error-500"
      >
        <path
          d="M14.5031 9.46875C14.2102 9.17578 13.7356 9.17578 13.4425 9.46875L12 10.9406L10.5031 9.46875C10.2102 9.17578 9.73563 9.17578 9.4425 9.46875C9.14937 9.76172 9.14953 10.2362 9.4425 10.5294L10.9122 11.9991L9.46875 13.4688C9.17578 13.7617 9.17578 14.2362 9.46875 14.5294C9.76166 14.8223 10.2362 14.8225 10.5294 14.5294L12 13.0594L13.4697 14.5291C13.7626 14.822 14.2372 14.8222 14.5303 14.5291C14.8233 14.2361 14.8233 13.7616 14.5303 13.4684L13.0606 11.9988L14.5303 10.5291C14.8219 10.2375 14.8219 9.7625 14.5031 9.46875ZM12 4C7.58125 4 4 7.58125 4 12C4 16.4187 7.58125 20 12 20C16.4187 20 20 16.4187 20 12C20 7.58125 16.4187 4 12 4ZM12 18.5C8.41563 18.5 5.5 15.5841 5.5 12C5.5 8.41594 8.41563 5.5 12 5.5C15.5844 5.5 18.5 8.41594 18.5 12C18.5 15.5841 15.5844 18.5 12 18.5Z"
        />
      </svg>
    </div>
  </div>

  <ng-container *ngIf="!showOnlyDelivery && selectedCampaigns![0]">
    <mobo-coupon-list
      listTitle="CUPONS SELECIONADOS"
      [campaigns]="selectedCampaigns"
      (seeAll)="seeAll()"
    ></mobo-coupon-list>
  </ng-container>

  <img
    *ngIf="!filters[0] && !showOnlyDelivery"
    src="assets/imgs/banners/banner-delivery_div_site.jpg"
    class="w-full"
    alt="banner de delivery"
  />

  <ng-container *ngIf="deliveryCampaigns![0]">
    <mobo-coupon-list
      listTitle="PARA DELIVERY"
      [campaigns]="deliveryCampaigns"
      (seeAll)="seeAll()"
    >
      <svg
        icon
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <path
          d="M16 7.5C14.9122 7.5 13.8488 7.82257 12.9444 8.42692C12.0399 9.03126 11.3349 9.89025 10.9187 10.8952C10.5024 11.9002 10.3935 13.0061 10.6057 14.073C10.8179 15.1399 11.3417 16.1199 12.1109 16.8891C12.8801 17.6583 13.8601 18.1821 14.927 18.3943C15.9939 18.6065 17.0998 18.4976 18.1048 18.0813C19.1098 17.6651 19.9687 16.9601 20.5731 16.0556C21.1774 15.1512 21.5 14.0878 21.5 13C21.4983 11.5418 20.9184 10.1438 19.8873 9.11274C18.8562 8.08165 17.4582 7.50165 16 7.5ZM16 15.5C15.5055 15.5 15.0222 15.3534 14.6111 15.0787C14.2 14.804 13.8795 14.4135 13.6903 13.9567C13.5011 13.4999 13.4516 12.9972 13.548 12.5123C13.6445 12.0273 13.8826 11.5819 14.2322 11.2322C14.5819 10.8826 15.0273 10.6445 15.5123 10.548C15.9972 10.4516 16.4999 10.5011 16.9567 10.6903C17.4135 10.8795 17.804 11.2 18.0787 11.6111C18.3534 12.0222 18.5 12.5055 18.5 13C18.5 13.663 18.2366 14.2989 17.7678 14.7678C17.2989 15.2366 16.663 15.5 16 15.5ZM16 1.5C12.951 1.50331 10.0279 2.71597 7.87193 4.87193C5.71597 7.02788 4.50331 9.95103 4.5 13C4.5 22.67 14.705 29.925 15.14 30.2288C15.3921 30.4052 15.6923 30.4998 16 30.4998C16.3077 30.4998 16.6079 30.4052 16.86 30.2288C18.7928 28.8043 20.5612 27.1692 22.1325 25.3538C25.6437 21.3213 27.5 17.0462 27.5 13C27.4967 9.95103 26.284 7.02788 24.1281 4.87193C21.9721 2.71597 19.049 1.50331 16 1.5ZM19.9125 23.3388C18.7207 24.7078 17.4115 25.9701 16 27.1112C14.5885 25.9701 13.2793 24.7078 12.0875 23.3388C10 20.9213 7.5 17.1637 7.5 13C7.5 10.7457 8.39553 8.58365 9.98959 6.98959C11.5837 5.39553 13.7457 4.5 16 4.5C18.2543 4.5 20.4163 5.39553 22.0104 6.98959C23.6045 8.58365 24.5 10.7457 24.5 13C24.5 17.1637 22 20.9213 19.9125 23.3388Z"
          fill="#F5A70E"
        />
      </svg>
    </mobo-coupon-list>
  </ng-container>

  <ng-container *ngIf="!filters[0] && !showOnlyDelivery">
    <mobo-coupon-list
      listTitle="NOVOS NO MOBO"
      [campaigns]="recentCampaigns"
      (seeAll)="seeAll()"
    >
      <svg
        icon
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
      >
        <path
          d="M25.5 13C25.5 13.3978 25.342 13.7794 25.0607 14.0607C24.7794 14.342 24.3978 14.5 24 14.5H14.5V24C14.5 24.3978 14.342 24.7794 14.0607 25.0607C13.7794 25.342 13.3978 25.5 13 25.5C12.6022 25.5 12.2206 25.342 11.9393 25.0607C11.658 24.7794 11.5 24.3978 11.5 24V14.5H2C1.60218 14.5 1.22064 14.342 0.93934 14.0607C0.658035 13.7794 0.5 13.3978 0.5 13C0.5 12.6022 0.658035 12.2206 0.93934 11.9393C1.22064 11.658 1.60218 11.5 2 11.5H11.5V2C11.5 1.60218 11.658 1.22064 11.9393 0.93934C12.2206 0.658035 12.6022 0.5 13 0.5C13.3978 0.5 13.7794 0.658035 14.0607 0.93934C14.342 1.22064 14.5 1.60218 14.5 2V11.5H24C24.3978 11.5 24.7794 11.658 25.0607 11.9393C25.342 12.2206 25.5 12.6022 25.5 13Z"
          fill="#F5A70E"
        />
      </svg>
    </mobo-coupon-list>
  </ng-container>

  <div
    class="flex flex-col items-center gap-4 p-10"
    *ngIf="!filteredCampaigns![0] || (showOnlyDelivery && !deliveryCampaigns![0])"
  >
    <h3 class="text-5xl font-semibold mb-6 text-center text-slate-400">
      NENHUM CUPOM ENCONTRADO
    </h3>
    <img
      class="mx-auto"
      width="400"
      height="400"
      [ngSrc]="baseUrl + '/assets/imgs/empty-wallet.svg'"
      alt="Mobo"
    />
  </div>
</div>
